import { Boxes, PackageCheck } from "lucide-react";
import { OperationalSearchField } from "@/components/operational/OperationalSearchField";

type CheckinTab = "items" | "boxes";

interface CheckinPageControlsProps {
  activeTab: CheckinTab;
  canShowBoxesTab: boolean;
  isSupplierView: boolean;
  searchTerm: string;
  onTabChange: (tab: CheckinTab) => void;
  onSearchChange: (value: string) => void;
}

function searchPlaceholder({
  activeTab,
  isSupplierView,
}: Pick<CheckinPageControlsProps, "activeTab" | "isSupplierView">) {
  if (activeTab === "boxes") return "Buscar por fornecedor...";
  return isSupplierView
    ? "Buscar por produto..."
    : "Buscar por produto ou fornecedor...";
}

export function CheckinPageControls({
  activeTab,
  canShowBoxesTab,
  isSupplierView,
  searchTerm,
  onTabChange,
  onSearchChange,
}: CheckinPageControlsProps) {
  return (
    <>
      <nav className="tabs" aria-label="Seções da carga">
        <button
          className={activeTab === "items" ? "active" : ""}
          type="button"
          aria-pressed={activeTab === "items"}
          data-active={activeTab === "items" ? "true" : undefined}
          onClick={() => onTabChange("items")}
        >
          <PackageCheck size={16} /> Itens
        </button>
        {canShowBoxesTab && (
          <button
            className={activeTab === "boxes" ? "active" : ""}
            type="button"
            aria-pressed={activeTab === "boxes"}
            data-active={activeTab === "boxes" ? "true" : undefined}
            onClick={() => onTabChange("boxes")}
          >
            <Boxes size={16} /> Caixas
          </button>
        )}
      </nav>

      <div className="detail-search">
        <OperationalSearchField
          value={searchTerm}
          onChange={onSearchChange}
          placeholder={searchPlaceholder({ activeTab, isSupplierView })}
          ariaLabel={searchPlaceholder({ activeTab, isSupplierView })}
        />
      </div>
    </>
  );
}
